// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"873":"e051c611","1945":"e051c611","5161":"e051c611","5842":"651922cf","6843":"e051c611","9400":"3b19255a"}[chunkId] + ".chunk.css";
};